/**
 * ProjectDataLoader — layout route mounted at /app/project/:projectId.
 *
 * Fetches and hydrates the project's data exactly once (via useProjectData)
 * and only renders its nested route (ProjectPage / InsightsPage / PlanPage,
 * or any future page added under this route) once loading finishes. Pages
 * nested here never need their own fetch/loading logic — they read
 * already-hydrated data straight from the store.
 */
import { Outlet, useOutletContext, useParams } from 'react-router-dom';
import { useProjectData } from '../../hooks/useProjectData';
import PageLoadingState from '../ui/PageLoadingState';
import { AppShellContext } from './AppShell';

export default function ProjectDataLoader() {
    const { projectId } = useParams<{ projectId: string }>();
    const outletContext = useOutletContext<AppShellContext>();
    const { loading, error } = useProjectData(projectId);

    if (error) {
        return (
            <div className='app-canvaswrap'>
                <PageLoadingState error={error} />
            </div>
        );
    }

    if (loading) {
        return (
            <div className='app-canvaswrap'>
                <PageLoadingState title='Loading project…' hint='Opening project — please wait.' />
            </div>
        );
    }

    return <Outlet context={outletContext} />;
}
